const stats = [
  { label: "Founded", value: "2022" },
  { label: "Athletes", value: "160+" },
  { label: "Events", value: "88" },
  { label: "Australians Reached", value: "2,200,000" },
  { label: "Athletes and Advancement Projects", value: ">$650,000" },
];

export default function Example() {
  return (
    <div className="py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
          <h2 className="text-base font-semibold leading-7 text-gold">
            Our Impact
          </h2>
          <div className="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row">
            <div className="lg:w-full lg:max-w-2xl lg:flex-auto">
              <h2 className="text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl mb-10">
                What we have done to support athletes within our network
              </h2>
              <p className="text-xl/8 text-gray-600">
                Self-funding can be a daunting challenge for many talented
                individuals who face the high costs of training, travel,
                equipment, and competition entry fees. For many athletes,
                especially those from underrepresented backgrounds, the journey
                to the Olympics or Paralympics can seem insurmountable without
                financial support. The urgency of our campaign is underscored by
                the limited time our athletes have to prepare and compete at the
                highest levels. Every moment counts; every dollar raised
                transforms into opportunities.
              </p>
              {/* <ul className="mt-5 text-xl font-josefin">
                <li>4 x Global Business Awards</li>
                <li>6 x National Business Awards</li>
                <li>55 TV Episodes</li>
              </ul> */}

              {/* <div>
                <div className="lg:flex lg:flex-auto lg:justify-center">
                  <dl className="w-64 space-y-8 xl:w-80">
                    <dt className="text-base/7 text-gray-600 font-bold"></dt>
                    <dd className="text-5xl font-black tracking-tight text-gold">
                      6
                    </dd>
                    National Business Awards
                  </dl>
                </div>
              </div>

              <div>
                <div className="lg:flex lg:flex-auto lg:justify-center">
                  <dl className="w-64 space-y-8 xl:w-80">
                    <dt className="text-base/7 text-gray-600 font-bold"></dt>
                    <dd className="text-5xl font-black tracking-tight text-gold">
                      55
                    </dd>
                    TV Episodes of 'For the Glory'
                  </dl>
                </div>
              </div>

              <div>
                <div className="lg:flex lg:flex-auto lg:justify-center">
                  <dl className="w-64 space-y-8 xl:w-80">
                    <dt className="text-base/7 text-gray-600 font-bold"></dt>
                    <dd className="text-5xl font-black tracking-tight text-gold">
                      100
                    </dd>
                    Podcast Interviews
                  </dl>
                </div>
              </div>

              <div>
                <div className="lg:flex lg:flex-auto lg:justify-center">
                  <dl className="w-64 space-y-8 xl:w-80">
                    <dt className="text-base/7 text-gray-600 font-bold"></dt>
                    <dd className="text-5xl font-black tracking-tight text-gold">
                      4
                    </dd>
                    Global Business Awards
                  </dl>
                </div>
              </div> */}
            </div>
            <div className="lg:flex lg:flex-auto lg:justify-center">
              <dl className="w-64 space-y-8 xl:w-80">
                {stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col-reverse gap-y-2"
                  >
                    <dt className="text-base/7 text-gray-600 font-bold">
                      {stat.label}
                    </dt>
                    <dd className="text-5xl font-black tracking-tight text-gold">
                      {stat.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
